/*
 *
 * NOTES
 *
 * This image gallery can be used multiple times per page.
 *
 * Use PubSub to call the modalImageGallery:openToImage event to open,
 * and pass in the galleryId (that is also passed into the twig file), and
 * the image Id to open the modal up to.
 *
 */

var PubSub = require("underpub-js");
var Wallop = require('wallop');
var Equalizer = require('equalizer');

var ModalImageGallery = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ModalImageGallery.prototype.init = function(){

  var self = this;

  var slider = this.options.$el.find('.Wallop')[0]; // wallop takes a plain JS element, so use [0]
  this.wallop = new Wallop(slider);
  
  // close modal on background click
  this.options.$el.on('click', function() {
    self.closeSliderModal();
  });

  // do not close modal when image is clicked
  this.options.$el.find('.Wallop').on('click', function(e) {
    e.stopPropagation();
  });

  // do not close modal when dots nav is clicked
  this.options.$el.find('.dots-nav').on('click', function(e) {
    e.stopPropagation();
  });
  
  
  // dots navigation
  this.options.$el.find(".dots-nav span").on("click", function(){
    var goToSlide = $(this).data("slideIndex");

    self.wallop.goTo(goToSlide);
  });

  // update dots when slide changes
  var slideChange = function(event) {

    var activeSlideNum = event.detail.currentItemIndex;
    self.options.$el.find('.dots-nav span').removeClass('active');
    self.options.$el.find('[data-slide-index=' + activeSlideNum + ']').addClass('active');

  };

  this.wallop.on('change', slideChange);
  

  // equalize wallop slide heights
  this.eq = new Equalizer('[data-image-gallery-modal] .Wallop .Wallop-item');

  PubSub.subscribe("resized", function(){
    console.log('align again');
    self.eq.align();
  });

  // argsArray = [galleryId, imageId]
  PubSub.subscribe('modalImageGallery:openToImage', function(functionArgs) {

    var galleryId = functionArgs[0];
    var imageId = functionArgs[1];

    if (self.options.$el.attr('id') == galleryId)
    {
      self.openSliderToImage(imageId - 1);
    }

  });

};

ModalImageGallery.prototype.openSliderToImage = function(imageId){

  var self = this;

  this.wallop.goTo(parseInt(imageId));
  this.openSliderModal();

};

ModalImageGallery.prototype.openSliderModal = function(imageId){

  this.eq.align();
  this.options.$el.removeClass('no-longer-shown').addClass('active');

};

ModalImageGallery.prototype.closeSliderModal = function(imageId){

  this.options.$el.removeClass('active').addClass('no-longer-shown');

};

module.exports = ModalImageGallery;
